<button mat-button (click)="logout()" *ngIf="loginDisplay" [ngClass]="{ 'collapsed': isCollapsed }">
  <mat-icon>logout</mat-icon>
  <span [hidden]="isCollapsed">Logout</span>
</button>

